const Colors = {
  primary: "#017A73",
  primary2: "#374557",
  fontPrimary: "#003E85",
  blueThemeColor: "#2C75B7",
  pinkThemeColor: "#F3A8C9",
  orangeThemeColor: "#F9A86F",
  purpleThemeColor: "#5C59A2",
  whiteThemeColor: "#fff",
  darkBlueColor: "#0C4579",
  grayColor: "#D6D6D6",
  darkGrayColor: "#404040",
  blackColor: "black",
  mediumGrayColor: "#979797",
  lightGrayColor: "#f5f5f5",
  lightGrayColor2: "#d3d3d3",
  lightGray: "#6666",
  lightBlue: "#B5E2FF",
  greenColor: "#64B161",
  lightGreen: "#97D4C4",
  redColor: "red",
  blackTheme: "#231F20",
  labelColor: "#5C6363",
  dangerColor: "#dc3545",
  disabled: "#B5B5B5",
  red: "#DB2628",
  border: "#9B9B9B",
  blue: "#003E85",
  decentBlue: "#E9F3FF",
  lightWhite: "#F8FAFC",
  hoverColor: "#E9FFFE;",
  lightTxt: "#64748B",
  darkWhite: "#F8F8F9",
  brown: "#7A0117",
  photoIcon:'#43A6C6',
  vidIcon:'#FF2E2E',
  AssIcon:'#9A463D',
  btnPrimary:'#24a0ed'
};
export default Colors;
